import { createPipe } from 'imask';
import validation from './input-validation';
import { ERROR_MESSAGES, FIELD_NAMES } from '../../constants';

const PostCodeInput = class {
  constructor() {
    this.name = FIELD_NAMES.postCode;
    this.label = ERROR_MESSAGES.userPostCode;
    this.required = true;
    this.pattern = '^[0-9]{2}(-)[0-9]{3}$';
    this.maskFn = createPipe({ mask: '00-000' });
    this.patternMessage = ERROR_MESSAGES.postCode;
    this.invalidZips = [];
    this.extraValidations = [];
    this.extraValidations.push(this.validateZip.bind(this));
  }

  addInvalidZips(zips = []) {
    this.invalidZips = [...this.invalidZips, ...zips];
  }

  validateZip(zip) {
    return validation.validation(!this.invalidZips.includes(zip), ERROR_MESSAGES.postalCode);
  }
};

export default PostCodeInput;
